<template>
  <div style="height:100vh">
    <div
      id="custom_dashboard_loading"
      class="vs-con-loading__container fullscreenDashboard"
    >
      <div class="flex flex-wrap">
        <vs-row
          style="margin-bottom: 1rem"
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="end"
        >
          <vs-col   vs-type="flex"
            vs-justify="center"
            vs-align="end" vs-w="1" >
            <h1 class="pl-4" :class="{ newDashboard: isActive }">
              <feather-icon
                icon="Minimize2Icon"
                class="inline-block"
                svgClasses="w-6 h-6"
                @click="normalSreen"
              />
            </h1>
          </vs-col>
        </vs-row>

        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <rh-cards class="w-full px-3" :refresh="refresh" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <ehs-donut class="w-full px-3" :refresh="refresh" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <compliance-donut class="w-full px-3" :refresh="refresh" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <pending-expense-donut class="w-full px-3" :refresh="refresh" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <invoiced-expense-donut class="w-full px-3" :refresh="refresh" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <warehouse-aging-pallet class="w-full px-3" :refresh="refresh" />
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import ComplianceDonut from './components/ComplianceDonut.vue'
import PendingExpenseDonut from './components/PendingExpenseDonut.vue'
import EhsDonut from './components/EhsDonut.vue'
import WarehouseAgingPallet from './components/WarehouseAgingPallet.vue'
import RhCards from './components/RhCards.vue'
import InvoicedExpenseDonut from './components/InvoicedExpenseDonut.vue'
export default {
  components: {
    ComplianceDonut,
    PendingExpenseDonut,
    EhsDonut,
    WarehouseAgingPallet,
    RhCards,
    InvoicedExpenseDonut,
  },
  data() {
    return {
      isActive: true,
      refresh: true,
      background: '#000',
    }
  },
  methods: {
    normalSreen() {
      this.$router.push({ path: '/' })
    },
    darkligth() {
      this.$store.dispatch('dashboard/turnLigthMode')
    },
    reloadCharts() {
      var v = this
      setInterval(function () {
        v.refresh = !v.refresh
      }, 15000)
    },
  },
  mounted() {
    this.reloadCharts()
  },
}
</script>
<style>
.newDashboard {
  background: #151d2f;
  color: white !important;
}

.darkModeCard {
  background: #273045 !important;
  color: white !important;
}
.altura {
  height: 43vh !important;
}

.widget-card-header,
.darkModeCard {
  color: white !important;
}
.darkModeCard .widget-card-header-style {
  color: white !important;
}

.letrasBlancas {
  color: white !important;
  font-size: 1.4em !important;
}
</style>